import * as React from "react";
import { Col, Row } from "components/bootstrap";
import { DocumentTitle, Link, PageHeader } from "components/common";
import CreateButton from "components/common/CreateButton";
import WarningRow from "components/common/WarningRow";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import AIManagementPageNavigation from "ai-management/AIManagementPageNavigation";
import { MODEL_PROVIDER_ENTITY_KEY } from "ai-management/Constants";
import { MODEL_PROVIDERS_TABLE_LAYOUT } from "ai-management/model-providers/Constants";
import fetchModelProviders, { keyFn } from "ai-management/model-providers/hooks/fetchModelProviders";
import columnRenderers from "ai-management/model-providers/overview/ColumnRenderers";
import ModelProviderActions from "ai-management/model-providers/overview/ModelProviderActions";
import AgentWorkflowRoutes from "aiagent/Routes";
import AIFeaturesStatusAlerts from "ai-management/components/AIFeaturesStatusAlerts";
import useAIConfiguration from "ai/hooks/useAIConfiguration";
import AIFeaturesToggle from "./AIFeaturesToggle";
const entityActions = (provider) => /* @__PURE__ */ React.createElement(ModelProviderActions, { provider });
const ModelProvidersOverviewPage = () => {
  const {
    data: { isEnabled: aiEnabled },
    isLoading: isLoadingAIConfiguration
  } = useAIConfiguration();
  const RowComponent = isLoadingAIConfiguration || aiEnabled ? Row : WarningRow;
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "AI Model Providers" }, /* @__PURE__ */ React.createElement(AIManagementPageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: "Model Providers", actions: /* @__PURE__ */ React.createElement(CreateButton, { entityKey: MODEL_PROVIDER_ENTITY_KEY }) }, /* @__PURE__ */ React.createElement("span", null, "Model providers connect AI features such as ", /* @__PURE__ */ React.createElement(Link, { to: AgentWorkflowRoutes.WORKFLOWS }, "AI Agent Workflows"), " ", "to providers like OpenAI or Anthropic. Features use the default model provider unless you assign them a different one.")), /* @__PURE__ */ React.createElement(RowComponent, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(AIFeaturesToggle, null))), /* @__PURE__ */ React.createElement(AIFeaturesStatusAlerts, { isModelProvidersPage: true }), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "model providers",
      tableLayout: MODEL_PROVIDERS_TABLE_LAYOUT,
      fetchEntities: fetchModelProviders,
      keyFn,
      columnRenderers,
      entityActions,
      entityAttributesAreCamelCase: false,
      noPageSizeSelect: true
    }
  ))));
};
export default ModelProvidersOverviewPage;
